<script setup lang="ts">
import { countryCodes } from '@/assets/Utils/countryCodes'

const props = defineProps<{
  phone: string
  phoneCode: string   // always just a string like "+354"
  disable?: boolean
  v$?: any
}>()

const emit = defineEmits<{
  (e: 'updatePhone', value: string): void
  (e: 'updateCode', value: string): void
}>()

// Helper: find the country object by dial_code
function findByDial(dial: string) {
  return countryCodes.find(c => c.dial_code === dial) || null
}

// Helper: get flag image path from assets
function getFlagPath(code: string) {
  if (!code) return ''
  try {
    return new URL(`../../../assets/flags/${code.toLowerCase()}.svg`, import.meta.url).href
  } catch {
    return ''
  }
}
</script>

<template>
  <div class="d-flex flex-wrap" style="padding-top: 8px;">
    <!-- Area code selector -->
    <div class="col-sm-12 col-md-5 animated__label autcomplete__input">
      <v-select
        class="country-select"
        :model-value="findByDial(phoneCode)"
        :items="countryCodes"
        :item-title="item => `${item.name} (${item.dial_code})`"
        item-value="code"
        return-object
        clearable
        :disabled="disable"
        density="comfortable"
        variant="outlined"
        :placeholder="$t('undirritun_umsokn_phone_code')"
        @update:modelValue="val => emit('updateCode', val?.dial_code ?? '')"
      >
        <!-- Selected value -->
        <template #selection="{ item }">
          <div class="d-flex align-center">
            <img
              v-if="item.raw.code"
              :src="getFlagPath(item.raw.code)"
              style="height:20px;width:20px;margin-right:6px"
            />
            {{ item.raw.name }} ({{ item.raw.dial_code }})
          </div>
        </template>

        <!-- Dropdown rows -->
        <template #item="{ props, item }">
          <v-list-item v-bind="props">
            <template #prepend>
              <img
                v-if="item.raw.code"
                :src="getFlagPath(item.raw.code)"
                style="height:20px;width:20px;margin-right:6px"
              />
            </template>

          </v-list-item>
        </template>
      </v-select>



        <div v-if="v$?.phoneCode?.$error">
          <div class="error__text" v-if="!v$.phoneCode.required">
            {{ $t('undirritun_umsokn_phone_code_error') }}
          </div>
        </div>
    </div>

    <!-- Phone number input -->
    <div class="col-sm-12 col-md-7 animated__label">
      <v-text-field
        id="sign__phone1"
        :model-value="phone"
        type="text"
        :disabled="disable"
        density="comfortable"
        variant="outlined"
        :placeholder="$t('undirritun_umsokn_simanumer')"
        :label="$t('umsokn_umsaekjandi_simanumer')"
        :width="200"
        @update:modelValue="val => emit('updatePhone', val ?? '')"
      />
    </div>
  </div>

</template>

<style scoped lang="scss">
.autcomplete__input {
  min-width: 220px;
}
</style>
